import _slicedToArray from "/codebuild/output/src748241224/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useRef } from "react";
import { useDrawerAnimation } from "../../../shared/animation";
import { useDisableScroll, useFocusTrap } from "../../../shared/hooks";
import { Accordion } from "../../Accordion";
import { Menu } from "../../Icons";
import { topLevelLinks, learnCategories, forBusinessesCategories, AccountLinks as BackupAccountLinks } from "../links";
import { productCategories, combinedProducts } from "../productLinks";
import * as S from "./styles";

var byTag = function byTag(e) {
  return function (_ref) {
    var t = _ref.tags;
    return t.includes(e);
  };
};

export var MobileMenu = function MobileMenu(_ref2) {
  var e = _ref2.loggedIn,
      t = _ref2.accountLinks;

  var _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      a = _useState2[0],
      l = _useState2[1],
      n = useDrawerAnimation(a),
      r = useRef();

  return useDisableScroll(a), useFocusTrap(r, a), React.createElement(React.Fragment, null, React.createElement(S.Hamburger, {
    "aria-label": "Open Menu",
    onClick: function onClick() {
      return l(!0);
    },
    "data-testid": "mobile-hamburger-menu"
  }, React.createElement(Menu, null)), n(function (a, n) {
    return n && React.createElement(S.MenuContainer, {
      style: a,
      ref: r,
      "data-testid": "mobile-menu-container"
    }, React.createElement(S.CloseButtonWrapper, {
      "data-testid": "mobile-menu-close-button",
      onClick: function onClick() {
        return l(!1);
      }
    }, React.createElement(S.CloseIcon, null)), React.createElement(S.MenuTop, null, React.createElement(S.MenuItem, {
      key: "shop-all",
      href: topLevelLinks.shopAll.url,
      "data-testid": "mobile-shop-all-link"
    }, topLevelLinks.shopAll.label), React.createElement(Accordion.Wrapper, null, productCategories.map(function (e) {
      return React.createElement(S.AccordionItem, {
        key: e.slug
      }, React.createElement(S.AccordionHeading, {
        dataTestId: "mobile-shop-category-" + e.slug
      }, e.displayName), combinedProducts.filter((t = e.slug, function (_ref3) {
        var e = _ref3.tags;
        return e.includes(t);
      })).map(function (_ref4, l) {
        var e = _ref4.label,
            t = _ref4.url,
            a = _ref4.slug;
        return React.createElement(S.AccordionChild, {
          key: "".concat(a, "-").concat(l)
        }, React.createElement(S.MenuItem, {
          "data-testid": a,
          href: t
        }, e));
      }));
      var t;
    }))), React.createElement(S.MenuMiddle, null, React.createElement(S.Button, {
      href: topLevelLinks.register.url,
      appearance: "secondary",
      "data-testid": "mobile-register-link"
    }, topLevelLinks.register.label), e ? null : React.createElement(S.Button, {
      href: topLevelLinks.login.url,
      appearance: "secondary",
      "data-testid": "mobile-login-link"
    }, topLevelLinks.login.label)), React.createElement(S.MenuBottom, null, React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
      "data-testid": "mobile-learn-heading"
    }, topLevelLinks.learn.label), Object.keys(learnCategories).map(function (e, t) {
      return React.createElement(S.MenuItem, {
        href: learnCategories[e].url,
        "data-testid": "mobile-learn-link-" + t,
        key: e
      }, e);
    })), React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
      "data-testid": "mobile-business-heading"
    }, topLevelLinks.business.label), Object.keys(forBusinessesCategories).map(function (e, t) {
      return React.createElement(S.MenuItem, {
        href: forBusinessesCategories[e].url,
        "data-testid": "mobile-business-link-" + t,
        key: e
      }, e);
    })), React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
      "data-testid": "mobile-support-heading"
    }, topLevelLinks.support.label), React.createElement(S.MenuItem, {
      href: topLevelLinks.support.url,
      "data-testid": "mobile-support-link"
    }, topLevelLinks.support.mobileSubcategoryLabel)), e && (t ? React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
      "data-testid": "mobile-account-heading"
    }, t.label), React.createElement(S.MenuItem, {
      href: t.results.url,
      "data-testid": "mobile-results-link"
    }, t.results.label), React.createElement(S.MenuItem, {
      href: t.settings.url,
      "data-testid": "mobile-settings-link"
    }, t.settings.label), React.createElement(S.MenuItem, {
      href: t.logout.url,
      "data-testid": "mobile-logout-link"
    }, t.logout.label)) : React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
      "data-testid": "mobile-account-heading"
    }, BackupAccountLinks.label), React.createElement(S.MenuItem, {
      href: BackupAccountLinks.results.url,
      "data-testid": "mobile-results-link"
    }, BackupAccountLinks.results.label), React.createElement(S.MenuItem, {
      href: BackupAccountLinks.settings.url,
      "data-testid": "mobile-settings-link"
    }, BackupAccountLinks.settings.label), React.createElement(S.MenuItem, {
      href: BackupAccountLinks.logout.url,
      "data-testid": "mobile-logout-link"
    }, BackupAccountLinks.logout.label)))));
  }));
};
export default MobileMenu;